export enum columnType {
    Corridor = 'Corridor',
    C_M = 'C-M',
    C_XS = 'C-XS',
    C_S1S2 = 'C-S1S2',
    C_L = 'C-L',
    C_XL = 'C-XL',

    V_P32C_C_M = 'V-P32C-C-M',
    
    V_P32C_2C_XS = 'V-P32C-2C-XS',
    
    V_P3C_C_L = 'V-P3C-C-L',
    V_P4C_C_L_C_XS = 'V-P4C-C-L-C-XS',
    
    V_P42C_C_XS_C_M = 'V-P42C-C-XS-C-M',
    
    V_P42C_3C_XS = 'V-P42C-3C-XS',

    V_P42C_C_XL = 'V-P42C-C-XL',

    V_P42_S1S2 = 'V-P42-S1S2',

    V_P52C_4C_XS = 'V-P52C-4C-XS',

    V_P52C_C_XS_C_M = 'V-P52C-C-XS-C-M',

    V_P52C_2C_M = 'V-P52C-2C-M',

    V_P5C_C_L_C_M = 'V-P5C-C-L-C-M',

    V_P5C_C_L_C_XS = 'V-P51C-C-L-C-XS',

    V_P52C_C_XS_2C_S = 'V-P52C-C-XS-2C-S',

    V_P52C_C_XS_C_XL = 'V-P52C-C-XS-C-XL',

    O_G = 'O-G',
    O_TL = 'O-TL',
    none = 'none',
}